import { GlobalImport } from '../../utils/GlobalImport';
import { MessageDialog } from '../../../framework/frontend/MessageDialog';

let recognition: any = null;
export function initSpeechToText(
  onStart: () => void,
  onEnd: () => void,
  onResult: (transcript: string, isFinish: boolean) => void
) {
  // WebkitSpeechRecognitionをサポートしているか確認
  if (!('webkitSpeechRecognition' in window)) {
    MessageDialog.error(
      'WebkitSpeechRecognitionはこのブラウザではサポートされていません。Chromeをお試しください。'
    );
    return;
  }

  // すでにインスタンスがスタートしていたら、同じインスタンスをかえす
  if (recognition) {
    console.log('すでにインスタンスがスタートしていたら、同じインスタンスをかえす');
    return recognition;
  }

  recognition = GlobalImport.getSpeechRecognition();
  let isRecognizing = false;

  recognition.lang = 'ja-JP';
  recognition.interimResults = true;
  recognition.continuous = true;

  recognition.onstart = function () {
    isRecognizing = true;
    onStart();
  };

  recognition.onend = function () {
    isRecognizing = false;
    onEnd();
  };

  recognition.onresult = function (event) {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; i++) {
      const transcript = event.results[i][0].transcript;
      if (event.results[i].isFinal) {
        interimTranscript += transcript;
        onResult(interimTranscript, true);
      } else {
        interimTranscript += transcript;
      }
    }

    console.log('interimTranscript', interimTranscript);
    onResult(interimTranscript, true);
  };

  return recognition;
}
